const END_POINT ="https://getform.io/f/5d0848dd-83f1-4a18-8f08-00da2f1b8e26"

export default END_POINT